function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import EmbeddedBoard from "segments/desktop/core-components/embedded-board/embedded-board";
import EmbeddedBoardDefaultProps from "segments/desktop/core-components/embedded-board/default-props";
import FullParagraph from "segments/desktop/core-components/full-paragraph/full-paragraph";
import { StyledEmbeddedBoardIframeComponent } from "./embedded-board-iframe-component.scss";
class EmbeddedBoardIframeComponent extends PureComponent {
    render() {
        const _this_props = this.props, { fullParagraph, embeddedBoardHeight, embeddedBoardWidth } = _this_props, restProps = _object_without_properties(_this_props, [
            "fullParagraph",
            "embeddedBoardHeight",
            "embeddedBoardWidth"
        ]);
        return /*#__PURE__*/ _jsxs(StyledEmbeddedBoardIframeComponent, {
            className: "embedded-board-iframe-component",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "full-paragraph-wrapper",
                    children: /*#__PURE__*/ _jsx(FullParagraph, _object_spread({}, fullParagraph))
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "embedded-board-wrapper",
                    style: {
                        height: embeddedBoardHeight,
                        width: embeddedBoardWidth
                    },
                    children: /*#__PURE__*/ _jsx(EmbeddedBoard, _object_spread({}, restProps))
                })
            ]
        });
    }
}
export { EmbeddedBoardIframeComponent as default };
EmbeddedBoardIframeComponent.defaultProps = _object_spread_props(_object_spread({}, EmbeddedBoardDefaultProps), {
    fullParagraph: _object_spread_props(_object_spread({}, FullParagraph.defaultProps), {
        title: "Get started with a board",
        body: "Drag and drop items, choose a status, add columns and items - everything is fully customizable to fit your workflow",
        textAlign: "center",
        topic: {}
    }),
    embeddedBoardHeight: "500px",
    embeddedBoardWidth: "80vw",
    paddingBottom: "64px"
});
